import { render, staticRenderFns } from "./TileDataContentHeader.vue?vue&type=template&id=06aaf838&"
import script from "./TileDataContentHeader.vue?vue&type=script&lang=js&"
export * from "./TileDataContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports